<template>
  <Popover ref="dropdownMenuPopover" :showHeader="true" :headerTitle="title" :placement="placement" sizeClass="popover-dropdown-menu">
    <ul class="dropdown-menu-popover">
      <slot />
    </ul>
  </Popover>
</template>

<style>
.popper-popover.popover-dropdown-menu {
  padding: 0px 0px 0rem 0px;
  min-width: 300px;
  width: 300px;
}
</style>

<script>
import Popover from '@/components/popover.vue'

export default {
  name: 'DropdownMenuPopover',
  components: {
    Popover
  },
  props: {
    title: String,
    placement: {
      type: String,
      default: 'right'
    },
  },
  data() {
    return {
      positionX: 0,
      positionY: 0
    }
  },
  methods: {
    displayFromElement(evt) {
      this.$refs.dropdownMenuPopover.displayFromElement(evt.target)
    },
    displayFromPosition(posX, posY) {
      this.positionX = posX
      this.positionY = posY

      let popoverComponent = this
      this.$refs.dropdownMenuPopover.displayFromElement({
        clientWidth: 1,
        clientHeight: 1,
        getBoundingClientRect: function() {
          return new DOMRect(popoverComponent.positionX, popoverComponent.positionY, 1, 1)
        },
        removeEventListener: function() {
        }
      })
    },
    hidePopover() {
      this.$refs.dropdownMenuPopover.hidePopover()
    }
  }
}
</script>